export default "__VITE_ASSET__ZrI1qfBE__"